import { track } from "../track";

interface Params {
  quiz_id?: string;
}

export const trackOnBoSignUpView = (params?: Params) =>
  track({ event: "on_bo_sign_up_view", ...params });
